import createStartThirdPartyDialogLogger from "./start-dialog";
import createThirdPartyContextLogger from "./context";
import createThirdPartyPasswordLogger from "./password";
export default function createThirdPartyAssessmentLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `third-party:${input.type}` });
    return {
        startDialog: createStartThirdPartyDialogLogger(log),
        context: createThirdPartyContextLogger(log),
        password: createThirdPartyPasswordLogger(log),
    };
}
